export async function exportRowsToExcel(rows, filename = "report.xlsx", sheetName = "Report") {
  const XLSX = await import("xlsx");
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  XLSX.writeFile(workbook, filename);
}

export function readExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const XLSX = await import("xlsx");
        const workbook = XLSX.read(event.target.result, { type: "array" });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        resolve(XLSX.utils.sheet_to_json(firstSheet));
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

export async function exportReportPdf({
  instituteName = "PARIKSIT",
  title = "Report",
  subtitle = "",
  summary = {},
  columns = [],
  rows = [],
  filename = "report.pdf"
}) {
  const [{ default: jsPDF }, { default: autoTable }] = await Promise.all([
    import("jspdf"),
    import("jspdf-autotable")
  ]);
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(2, 132, 199);
  doc.roundedRect(32, 28, pageWidth - 64, 72, 14, 14, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(instituteName, 54, 60);
  doc.setFontSize(13);
  doc.setFont("helvetica", "normal");
  doc.text(title, 54, 82);
  if (subtitle) doc.text(subtitle, pageWidth - 54, 82, { align: "right" });

  doc.setTextColor(15, 23, 42);
  const summaryRows = Object.entries(summary).map(([label, value]) => ({ label, value }));
  let currentY = 122;
  if (summaryRows.length) {
    autoTable(doc, {
      startY: currentY,
      theme: "grid",
      head: [["Metric", "Value"]],
      body: summaryRows.map((item) => [item.label, item.value]),
      styles: { fontSize: 9, cellPadding: 6 },
      headStyles: { fillColor: [14, 165, 233], textColor: [255, 255, 255] },
      margin: { left: 32, right: 32 }
    });
    currentY = doc.lastAutoTable.finalY + 18;
  }

  autoTable(doc, {
    startY: currentY,
    head: [columns.map((column) => column.header)],
    body: rows.map((row) => columns.map((column) => row[column.key] ?? "")),
    styles: { fontSize: 7, overflow: "linebreak", cellPadding: 4 },
    headStyles: { fillColor: [2, 132, 199], textColor: [255, 255, 255] },
    alternateRowStyles: { fillColor: [240, 249, 255] },
    margin: { left: 32, right: 32 }
  });

  doc.save(filename);
}
